<template>
    <div class="form-success">
        <h3>
            Obrigado Pelo seu registo!
        </h3>

        <h4>Em breve <b>irá receber um email</b> com o seu novo número de Cartão Makro.</h4>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>
<style lang="scss">
@import '~@/assets/scss/partials/variables';

.form-success {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 431px;
    width: 100%;
    height: 526px;
    background-color: #fff;
    color: $makro-blue;

    h3 {
        font-weight: 700;
        font-size: 36px;
        &::after {
            margin-top: -10px;
            margin-bottom: 10px;
            width: 27px;
            content: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.67 15.24"><path d="M13.34,10.65,23.42.56A1.9,1.9,0,0,1,24.77,0a1.88,1.88,0,0,1,1.34.56,1.92,1.92,0,0,1,0,2.7L14.69,14.69a1.91,1.91,0,0,1-2.63.05L.56,3.26A1.9,1.9,0,0,1,1.41.07,1.89,1.89,0,0,1,3.25.56Z" fill="%23ffe61c"/></svg>');
            @apply tw-block tw-m-auto;
        }
    }
}

</style>
